<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import BottomNav from '@/components/BottomNav.vue';
import { useSessionStore } from '@/stores/session';
import { useToast } from '@/composables/useToast';

const route = useRoute();
const { t } = useI18n();
const session = useSessionStore();
const toast = useToast();
const showTabs = computed(() => !!route.meta.tab);
</script>

<template>
  <div class="app-shell">
    <div v-if="session.status === 'loading' || session.status === 'idle'" class="boot">
      <div class="wordmark">em<span>city</span></div>
    </div>
    <div v-else-if="session.status === 'error'" class="boot">
      <p class="hint" style="text-align: center">{{ t('boot.error') }}</p>
    </div>
    <template v-else>
      <div class="app-content"><router-view /></div>
      <BottomNav v-if="showTabs" />
    </template>
    <div v-if="toast.message.value" class="toast">{{ toast.message.value }}</div>
  </div>
</template>

<style scoped>
.app-shell {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100dvh;
  max-width: 520px;
  margin: 0 auto;
  background: var(--color-bg);
  box-shadow: 0 0 0 1px var(--color-border-softer);
}
.app-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}
.boot {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
</style>
